<span class="cron-viewer-days" [ngClass]="{ 'paused': schedulePaused }">
    {{ getScheduledDays() }}
</span>
@if (condensed) {
    <div class="d-flex cron-viewer-hours" [ngClass]="classes">
        @if (hours.length === 1) {
            <ng-container *ngTemplateOutlet="hourDisplay; context: { $implicit: hours[0] }"></ng-container>
        } @else if (hours.length > 1) {
            <button
                type="button"
                (click)="toggleHours()"
                class="btn btn-link text-secondary btn-sm px-0 text-decoration-none hours-view-button"
                [class.cron-viewer-hours-collapsed-toggle]="!hoursList"
            >
                @if (!hoursList) {
                    <fa-icon [icon]="hoursListClosedIcon" class="me-1" [fixedWidth]="true"></fa-icon><span class="cron-viewer-server-time">{{ hours.length }} times/day</span>
                } @else {
                    <div class="d-flex">
                        <fa-icon [icon]="hoursListOpenedIcon" class="me-1" [fixedWidth]="true"></fa-icon>
                        <div class="vstack align-items-start">
                            @for (hour of hours; track $index; let first = $first) {
                                <ng-container *ngTemplateOutlet="hourDisplay; context: { $implicit: hour }"></ng-container>
                            }
                        </div>
                    </div>
                }
            </button>
            @if (!hoursList) {
                <div class="cron-viewer-hours-print-expanded vstack align-items-start">
                    @for (hour of hours; track $index) {
                        <ng-container *ngTemplateOutlet="hourDisplay; context: { $implicit: hour }"></ng-container>
                    }
                </div>
            }
        }
    </div>
} @else {
     @for (hour of hours; track $index; let first = $first) {
        <div
            class="d-flex cron-viewer-hours"
            [ngClass]="classes">
                <ng-container *ngTemplateOutlet="hourDisplay; context: { $implicit: hour }"></ng-container>
        </div>
    }
}


<ng-template #hourDisplay let-hour>
    @if (!displaySettingsTimeZone) {
        <span class="cron-viewer-server-time mb-1 text-secondary" [ngClass]="{ 'paused': schedulePaused }">{{ hour.local }}</span>
    } @else {
        <div class="d-flex">
            <span class="cron-viewer-local-time mb-1" [ngClass]="{ 'paused': schedulePaused }">{{ hour.local }}</span>
            <span class="cron-viewer-divider mb-1 mx-1 text-secondary" [ngClass]="{ 'paused': schedulePaused }">|</span>
            <span class="cron-viewer-server-time mb-1 text-secondary" [ngClass]="{ 'paused': schedulePaused }">{{ hour.server }}</span>
        </div>
    }
</ng-template>
